"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_bootstrap_1 = require("react-bootstrap");
var DpModalFooter = function (_a) {
    var children = _a.children, className = _a.className;
    return ((0, jsx_runtime_1.jsx)(react_bootstrap_1.Modal.Footer, { "data-testid": "dp-modal-footer", className: className, children: children }));
};
exports.default = DpModalFooter;
